import { render, staticRenderFns } from "./TicketHBNotes.vue?vue&type=template&id=47db8a6d&"
import script from "./TicketHBNotes.vue?vue&type=script&lang=ts&"
export * from "./TicketHBNotes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports